























































import { Vue, Component, Mixins, Ref, Watch } from 'vue-property-decorator'
import ModalStudyConfirm from '@/components/student/organisms/ModalStudyConfirm.vue'
import ModalStudyComplete from '@/components/student/organisms/ModalStudyComplete.vue'
import ModalStudyTimeOrver from '@/components/student/organisms/ModalStudyTimeOrver.vue'
import StudyDummy1 from '@/components/student/organisms/StudyDummy1.vue'
import StudyDummy2 from '@/components/student/organisms/StudyDummy2.vue'
import StudyDummy3 from '@/components/student/organisms/StudyDummy3.vue'
import StudyDummy4 from '@/components/student/organisms/StudyDummy4.vue'
import StudyDummy5 from '@/components/student/organisms/StudyDummy5.vue'
import StudyDummy6 from '@/components/student/organisms/StudyDummy6.vue'
import StudyDummy7 from '@/components/student/organisms/StudyDummy7.vue'
import StudyDummy8 from '@/components/student/organisms/StudyDummy8.vue'
import StudyApis, { QuestionAnswerType, StudyDummyBaseMethod } from '@/mixins/requests/student/StudyApis.vue'
import SessionStorageMethods from '@/mixins/SessionStorageMethods.vue'
import CookieMethods from '@/mixins/CookieMethods.vue'
import StudyResultApis from '@/mixins/requests/student/StudyResultApis.vue'
import WebIME from '@/plugins/webime'

Vue.use(WebIME)

const common = require('../../../public/dummy/study/js/common-module.js')

@Component({
  components: {
    ModalStudyConfirm,
    ModalStudyComplete,
    ModalStudyTimeOrver,
    StudyDummy1,
    StudyDummy2,
    StudyDummy3,
    StudyDummy4,
    StudyDummy5,
    StudyDummy6,
    StudyDummy7,
    StudyDummy8,
  },
})
export default class StudentStudy extends Mixins(SessionStorageMethods, CookieMethods, StudyApis, StudyResultApis) {
  private questionAnswers: QuestionAnswerType[] = [
    { tagName: 'tag1', duration: 0 },
    { tagName: 'tag2', duration: 0 },
    { tagName: 'tag3', duration: 0 },
    { tagName: 'tag4', duration: 0 },
    { tagName: 'tag5', duration: 0 },
    { tagName: 'tag6-1', duration: 0 },
    { tagName: 'tag6-2', duration: 0 },
    { tagName: 'tag7', duration: 0 },
  ]
  private currentTagName = 'tag1'

  // テスト開始からトータルの経過時間(秒)
  private durationTotal = 0
  // テストの総合制限時間
  private timeLimitTotal = 1800
  // 経過時間タイマー(setIntervalの戻り値はnumber型)
  private durationTotalTimer?: number

  @Ref()
  studyDummy!: StudyDummyBaseMethod

  // ref: 完了確認モーダル
  @Ref() modalStudyConfirm!: ModalStudyConfirm

  // ref: 提出完了モーダル
  @Ref() modalStudyComplete!: ModalStudyComplete

  // ref: 時間切れモーダル
  @Ref() modalStudyTimeOrver!: ModalStudyTimeOrver

  private async created() {
    // リロードされた時の入力値をSessionStorageから取得
    const restoreData = this.questionAnswersSessionStorage
    if (restoreData) this.questionAnswers = restoreData

    if (await this.getIsCompleted()) {
      // 受験済みの場合、結果画面に遷移
      this.$router.push({ name: 'StudentStudyResult' })
    }
  }

  private mounted() {
    //frame限定
    common.pageCreate()
    common.footerReset()
    common.selectTag(this.currentTagName)

    let scriptEl = document.createElement('script')
    scriptEl.setAttribute('src', '/dummy/study/js/common.js')
    ;(document.getElementById('base') as HTMLElement).appendChild(scriptEl)

    // 経過時間のカウントアップタイマーセット
    this.setDurationTimer()
  }

  private get currentQuestionAnswerIndex() {
    return this.questionAnswers.findIndex((q: any) => q.tagName == this.currentTagName)
  }

  private get currentQuestionAnswer() {
    return this.questionAnswers[this.currentQuestionAnswerIndex]
  }

  private get currentComponent() {
    return `StudyDummy${this.currentQuestionAnswerIndex + 1}`
  }

  private click2(mode: string) {
    const index = this.currentQuestionAnswerIndex + (mode == 'next' ? 1 : -1)
    if (index <= 7) {
      // フッターのボタンで問題を移動した時はタグの切り替えを行う
      this.currentTagName = this.questionAnswers[index].tagName || 'tag1'
      const target = document.getElementById(this.currentTagName)
      if (target) target.dispatchEvent(new Event('click'))
    } else {
      // 終わりボタン押下時は、最後の問題の入力値を取得
      this.questionAnswers[this.currentQuestionAnswerIndex] = Object.assign(
        this.questionAnswers[this.currentQuestionAnswerIndex],
        this.studyDummy.getQuestionAnswer()
      )
      this.setQuestionDuration(this.questionAnswers[this.currentQuestionAnswerIndex])
      this.showConfirmModal()
    }
  }

  private click3() {
    // やり直し
    this.studyDummy.clearInputedElements()
  }

  @Watch('currentQuestionAnswerIndex')
  onCurrentQuestionAnswerIndex(_newValue: number, oldValue: number) {
    // 問題切り替え時に入力値を取得
    this.questionAnswers[oldValue] = Object.assign(this.questionAnswers[oldValue], this.studyDummy.getQuestionAnswer())
    // duration計測
    this.setQuestionDuration(this.questionAnswers[oldValue])
    // リロードの時の為にSessionStorageに保存
    this.setQuestionAnswersSessionStorage(this.questionAnswers)
  }

  private get remainingTime() {
    const remaining = this.timeLimitTotal - this.durationTotal
    // 制限時間を過ぎた場合は0分0秒表示
    if (remaining < 0) return '0分0秒'
    return `${((remaining / 60) | 0).toFixed()}分${(remaining % 60).toFixed()}秒`
  }

  /**
   * 経過時間タイマーをセット
   */
  private setDurationTimer() {
    this.durationTotal = this.sumQestionDurationTotal()
    this.durationTotalTimer = setInterval(() => {
      this.durationTotal += 1
    }, 1000)
  }

  /**
   * 設問毎に保持するdurationの合計値取得
   */
  private sumQestionDurationTotal(): number {
    return this.questionAnswers.reduce((sum, answer) => {
      return sum + (answer.duration || 0)
    }, 0)
  }

  /**
   * 設問の経過時間を算出し、durationに加算する
   */
  private setQuestionDuration(answer: QuestionAnswerType) {
    // duration計測
    const diffDuration = this.durationTotal - this.sumQestionDurationTotal()
    answer.duration = (answer.duration || 0) + diffDuration
  }

  private get currentQuestionCount() {
    return `${this.currentQuestionAnswerIndex + 1}問目/8問中`
  }

  /**
   * 完了確認モーダル表示 (メニューからイベント検知)
   */
  private showConfirmModal() {
    this.modalStudyConfirm.show()
  }

  /**
   * 試験完了 (確認モーダルからイベント検知)
   */
  private async studyComplete() {
    Vue.prototype.$loading.start()
    await this.studyCompleteApi(
      this.questionAnswers,
      () => {
        this.modalStudyConfirm.hide()
        this.modalStudyComplete.show()
      },
      () => {
        alert('エラーが発生しました')
      }
    )
    Vue.prototype.$loading.complete()
  }

  /**
   * 試験強制終了 (実施時間からイベント検知)
   */
  private async studyStop() {
    Vue.prototype.$loading.start()
    await this.studyCompleteApi(
      this.questionAnswers,
      () => {
        this.studyEnd()
      },
      () => {
        alert('エラーが発生しました')
      }
    )
    Vue.prototype.$loading.complete()
  }

  /**
   * 提出完了（確認モーダルからイベント検知)
   */
  private studyEnd() {
    // SessionStorageをクリア
    this.clearSessionStorage()

    // 結果画面に遷移
    this.$router.push({ name: 'StudentStudyResult' })
    window.open(
      'https://docs.google.com/forms/d/e/1FAIpQLSeoX23L2YCoGc5mtn_TRpwQ24Oeup2LjsJZvDNp5fKrHlfORg/viewform?usp=sf_link',
      '_blank'
    )
  }
}
